import clsx from 'clsx';
import React from 'react';

import { useBlueconicContext } from '@contexts/BlueconicContext';
import useEventTracking from '@hooks/useEventTracking';
import { Theme } from '@interfaces/global';
import { article_path } from '@routes';
import { ClickTarget, click } from '@tracking';
import { captureBlueconicClickEvent } from '@utils/blueconic/utils';

interface ArticleHeaderProps {
  className?: string;
  offerCode?: string;
  slug: string;
  target?: string;
  title: string;
  theme?: Theme;
}

const ArticleHeader = ({
  className,
  offerCode,
  slug,
  target,
  title,
  theme = Theme.Light,
  ...rest
}: ArticleHeaderProps) => {
  const { trackEvent } = useEventTracking();
  const { variantId } = useBlueconicContext();

  const clickTargetCapture = () => {
    trackEvent(click({ clickTarget: ClickTarget.Headline, clickText: title }));
    if (variantId) {
      captureBlueconicClickEvent(variantId);
    }
  };

  return (
    <h3
      className={clsx('m-0 mb-4 font-suisse-works', className, {
        'text-black': theme === Theme.Light,
        'text-white': theme === Theme.Dark,
      })}
      {...rest}
    >
      <a
        href={article_path(slug, offerCode ? { offer: offerCode } : undefined)}
        onClickCapture={clickTargetCapture}
        className={clsx('text-balance transition-colors duration-200', {
          'text-black': theme === Theme.Light,
          'text-white': theme === Theme.Dark,
        })}
        target={target}
      >
        <div className="hover:text-primary-magenta">{title}</div>
      </a>
    </h3>
  );
};

export default ArticleHeader;
